const connected = (target, propertyKey) => {
  const connectedCallback = target.connectedCallback ?? (() => undefined);

  Reflect.defineProperty(target, "connectedCallback", {
    value() {
      Reflect.apply(connectedCallback, this, arguments);
      return this[propertyKey](...arguments);
    },
    writable: true,
  });
};

export default connected;
